// America/Sao_Paulo = UTC-3 fixo (Brasil sem horário de verão desde 2019).
// Formatação manual via getUTC* (sem Intl/locale) para garantir saída idêntica
// no servidor (SSR) e no cliente, independente dos dados de ICU do runtime —
// o Node do Alpine traz ICU reduzido e fazia pt-BR cair em en-US, quebrando a
// hidratação (React #418).
const SAO_PAULO_UTC_OFFSET_MINUTES = -3 * 60;

export function formatDateTime(date: Date) {
  const local = new Date(date.getTime() + SAO_PAULO_UTC_OFFSET_MINUTES * 60_000);
  const day = String(local.getUTCDate()).padStart(2, "0");
  const month = String(local.getUTCMonth() + 1).padStart(2, "0");
  const year = local.getUTCFullYear();
  const hours = String(local.getUTCHours()).padStart(2, "0");
  const minutes = String(local.getUTCMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}h${minutes}`;
}

// Data da primeira publicação (coluna first_published_at, imutável). Diferente
// de published_at, que é redefinida a cada publicação/republicação.
export function formatFirstPublishedDate(firstPublishedAt: string | null) {
  if (!firstPublishedAt) {
    return "Data não disponível";
  }

  const date = new Date(firstPublishedAt);
  if (Number.isNaN(date.getTime())) {
    return "Data não disponível";
  }

  return formatDateTime(date);
}

// Versão determinística usada no SSR e no primeiro render do cliente.
export function formatUpdatedAbsolute(updatedAt: string | null) {
  if (!updatedAt) {
    return "Atualizado há pouco";
  }

  const date = new Date(updatedAt);
  if (Number.isNaN(date.getTime())) {
    return "Atualizado há pouco";
  }

  return `Atualizado em ${formatDateTime(date)}`;
}

// O rótulo relativo ("há X minutos") depende de Date.now(), que difere entre o
// render no servidor (SSR) e a hidratação no cliente. Só deve ser usado após o
// mount para não quebrar a hidratação (React #418).
export function formatUpdatedLabel(updatedAt: string | null) {
  if (!updatedAt) {
    return "Atualizado há pouco";
  }

  const date = new Date(updatedAt);
  if (Number.isNaN(date.getTime())) {
    return "Atualizado há pouco";
  }

  const diffInMinutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
  if (diffInMinutes < 1) {
    return "Atualizado há pouco";
  }

  if (diffInMinutes < 60) {
    return `Atualizado há ${diffInMinutes} ${diffInMinutes === 1 ? "minuto" : "minutos"}`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `Atualizado há ${diffInHours} ${diffInHours === 1 ? "hora" : "horas"}`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `Atualizado há ${diffInDays} ${diffInDays === 1 ? "dia" : "dias"}`;
  }

  return `Atualizado em ${formatDateTime(date)}`;
}
